module.exports = __webpack_public_path__ + "static/media/header-background.1e3f73dc.png";